import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

import { CommandDeckShell } from './CommandDeckShell'
import { getCommandDeckPreviewBundle } from './lib/getCommandDeckPreviewBundle'

/** Preview-only Command Deck (`/command-deck/preview`). Uses fixtures + `?accessProfile=`. */
export function CommandDeckPage() {
  const [searchParams] = useSearchParams()
  const profileParam = searchParams.get('accessProfile')
  const bundle = useMemo(
    () => getCommandDeckPreviewBundle(profileParam),
    [profileParam]
  )

  return (
    <CommandDeckShell
      mode="preview"
      bundle={bundle}
      unlocked={bundle.accessProfileId === 'creator_beta'}
    />
  )
}
